/** @file keyedNodes: every node a clip keys, in order of first appearance. */
import type { Clip } from '@zilo/pose3d-format/types/clip';

/** The node names of all keys of `clip`, each once. */
export function keyedNodes(clip: Pick<Clip, 'keys'>): string[] {
  return [...new Set(clip.keys.flatMap((k) => Object.keys(k.nodes)))];
}
